exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div#fc_frame.fc-widget-normal.fc-mobile-view {\n  margin-bottom: 0;\n}\n\ndiv#fc_frame.fc-widget-normal {\n  margin-bottom: 60px;\n  z-index: 101;\n}\n", ""]);

